import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/modules/shared.module';
import { WeatherCardComponent } from './weather-card/weather-card.component';
import { StationWxComponent } from './weather-card/station-wx/station-wx.component';

@NgModule({
  declarations: [WeatherCardComponent, StationWxComponent],
  imports: [CommonModule, SharedModule],
  exports: [WeatherCardComponent],
})
export class WeatherModule {}
